import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    allRecentAnswersData: [],
    errors: [],
};

export const slice = createSlice({
    name: "allRecentAnswers",
    initialState,
    reducers: {
        clearAllRecentAnswersData: () => initialState,
        setAllRecentAnswersLoading: (state, action) => {
            state.isLoading = true;
        },
        setAllRecentAnswersData: (state, action) => {
            state.isLoading = false;
            state.allRecentAnswersData = action.payload;
        },
        setAllRecentAnswersError: (state, action) => {
            state.isLoading = false;
            state.errors = action.payload;
        },
        clearAllRecentAnswersError: (state) => {
            state.isLoading = false;
            state.errors = [];
        },
    },
});

export const {
    clearAllRecentAnswersData,
    setAllRecentAnswersLoading,
    setAllRecentAnswersData,
    setAllRecentAnswersError,
    clearAllRecentAnswersError,
} = slice.actions;

export default slice.reducer;